import React, { useState } from 'react';
import './CreditCardDisclaimer.scss';
import { FormattedMessage, injectIntl } from '../../localization';
import { formattedServiceNames } from '../../utils/configs';
import { Link } from 'ouisys-component-library';
import { useRootContext } from '../../providers/RootContext';

import DisclaimerModal from './DisclaimerModal';

const CreditCardDisclaimer = ({ className, intl }: { className?: string; intl: any }) => {
  const { serviceName, getLink } = useRootContext();
  // const [isModalOpen, setIsModalOpen] = useState(false);

  const defaultMessages = {
    disclaimerMain: {
      id: 'disclaimerMain',
      defaultMessage:
        '{serviceName} is a product of Prizeflix B.V. Prizeflix B.V. is a company registered in the Banks with an office registered at Van Diemenstraat 356, 1013 CR, Amsterdam. All contents of this website are owned by Prizeflix B.V.'
    }
  };

  return (
    <>
      {/* {isModalOpen && <DisclaimerModal setState={setIsModalOpen} />} */}
      <div className={`credit-card-disclaimer ${className || ''}`}>
        <p>
          {intl
            .formatMessage(defaultMessages.disclaimerMain)
            .replace('{serviceName}', formattedServiceNames[serviceName])}
        </p>
        <div className="terms-links">
          <Link href={getLink('aboutLink')}>
            <FormattedMessage id="aboutUs" defaultMessage="About Us" />
          </Link>
          <Link href={getLink('contactLink')}>
            <FormattedMessage id="contactUs" defaultMessage="Contact Us" />
          </Link>
          <Link href={getLink('privacyLink')}>
            <FormattedMessage id="privacyPolicy" defaultMessage="Privacy Policy" />
          </Link>
          <Link href={getLink('refundLink')}>
            <FormattedMessage id="refundPolicy" defaultMessage="Refund Policy" />
          </Link>
          <Link href={getLink('termsLink')}>
            <FormattedMessage id="termsAndConditions" defaultMessage="Terms & Conditions" />
          </Link>
          {/* <Link href={serviceLink[serviceName].faqLink} target="_blank">
            <FormattedMessage id="faq" defaultMessage="FAQ" />
          </Link> */}
          <Link href={getLink('refundLink')}>
            <FormattedMessage id="cancellationRefund" defaultMessage="Cancellation and Refund" />
          </Link>
        </div>
      </div>
    </>
  );
};

export default injectIntl(CreditCardDisclaimer);
